import { Menu, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'

import BrandsIcon from '../../../assets/images/icons/brands-icon.svg?react'
import ButtonDown300 from '../../../assets/images/icons/button-down-icon-300.svg?react'
import ButtonUp200 from '../../../assets/images/icons/button-up-icon-200.svg?react'
import CategoriesIcon from '../../../assets/images/icons/categories-icon.svg?react'
import CogIcon from '../../../assets/images/icons/cog.svg?react'
import CompetitorsIcon from '../../../assets/images/icons/competitors-icon.svg?react'
import ProductsBox from '../../../assets/images/icons/products.svg?react'
import { IntercomEvent } from '../../../utils/helpers/getIntercomMsg'
import useIntercomInternal from '../../../utils/hooks/use-intercom-internal'

function ManageDropdown(): JSX.Element {
  const [isOpenManageDropdown, setIsOpenManageDropdown] = useState(false)
  const { trackEventInternal } = useIntercomInternal()

  return (
    <>
      <Menu
        as="div"
        className="relative text-left pr-3  sm:pt-0 w-full sm:w-min"
      >
        <div>
          <Menu.Button
            onClick={() => setIsOpenManageDropdown((current) => !current)}
            className="flex flex-row items-center justify-center px-3 lg:px-4 py-2.5 border border-solid rounded-lg border-gray-300 w-full"
          >
            <CogIcon className="mr-2" />
            <span className="mr-2">Manage</span>
            {isOpenManageDropdown ? <ButtonUp200 /> : <ButtonDown300 />}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute lg:right-0 mt-1 w-56 origin-top-right divide-y divide-gray-200 rounded-md bg-white-100 shadow-lg  z-10">
            <div className="px-1 py-1">
              <Menu.Item>
                <Link
                  to="/manage/products"
                  onClick={() => {
                    trackEventInternal(
                      IntercomEvent['Bulk Action -> Product Tab Clicked'],
                    )
                  }}
                >
                  <button className=" text-gray-900 hover:bg-gray-50 group flex w-full items-center rounded-md px-2 py-2 text-sm">
                    <ProductsBox />
                    <span className="font-normal text-sm text-gray-700 pl-3">
                      Products
                    </span>
                  </button>
                </Link>
              </Menu.Item>
              <Menu.Item>
                <Link
                  to="/manage/brands"
                  onClick={() => {
                    trackEventInternal(
                      IntercomEvent['Bulk Action -> Brand Tab Clicked'],
                    )
                  }}
                >
                  <button className=" text-gray-900 hover:bg-gray-50 group flex w-full items-center rounded-md px-2 py-2 text-sm">
                    <BrandsIcon />
                    <span className="font-normal text-sm text-gray-700 pl-3">
                      Brands
                    </span>
                  </button>
                </Link>
              </Menu.Item>
              <Menu.Item>
                <Link
                  to="/manage/categories"
                  onClick={() => {
                    trackEventInternal(
                      IntercomEvent['Bulk Action -> Category Tab Clicked'],
                    )
                  }}
                >
                  <button className=" text-gray-900 hover:bg-gray-50 group flex w-full items-center rounded-md px-2 py-2 text-sm">
                    <CategoriesIcon />
                    <span className="font-normal text-sm text-gray-700 pl-3">
                      Categories
                    </span>
                  </button>
                </Link>
              </Menu.Item>
              <Menu.Item>
                <Link
                  to="/manage/competitors"
                  onClick={() => {
                    trackEventInternal(
                      IntercomEvent['Bulk Action -> Competitor Tab Clicked'],
                    )
                  }}
                >
                  <button className=" text-gray-900 hover:bg-gray-50 group flex w-full items-center rounded-md px-2 py-2 text-sm">
                    <CompetitorsIcon />
                    <span className="font-normal text-sm text-gray-700 pl-3">
                      Competitors
                    </span>
                  </button>
                </Link>
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  )
}

export default ManageDropdown
